import Segment from '../segment';

export function logOut(): void {
  Segment.reset();
  window.location.href = '/logout';
}
